// giftConstants.js
'use strict';

/**
 * Gift `ui_type` returned by the gift API. It decides which animation the
 * client plays when the gift is sent. A gift without `ui_type` has no
 * animation.
 *
 * `beauty_effect` is a byteplus sticker played by the native apps on the
 * broadcaster's camera feed. Web has no equivalent, so it is listed here only
 * so it is never mistaken for an `apng` / `pag` animation.
 */
const GiftUiType = {
  APNG: 'apng',
  PAG: 'pag',
  EMOJI: 'emoji',
  BEAUTY_EFFECT: 'beauty_effect',
};

export { GiftUiType };
